export const extractError = (error: any) => {
  try {
    return error.response.errors[0].message;
  } catch (err) {
    console.warn(err);
    return '';
  }
};
